import { render } from "./template-children-modal.vue?vue&type=template&id=b7940ea8&scoped=true"
import script from "./template-children-modal.vue?vue&type=script&lang=js"
export * from "./template-children-modal.vue?vue&type=script&lang=js"

import "./template-children-modal.vue?vue&type=style&index=0&id=b7940ea8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7940ea8"]])

export default __exports__